export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-[720px] md:min-h-[820px] flex items-center overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Abstract%20futuristic%20digital%20cityscape%20network%20with%20navy%20blue%20and%20warm%20orange%20light%20streams%20flowing%20across%20a%20dark%20geometric%20architecture%20landscape%2C%20glowing%20data%20centers%20on%20the%20horizon%2C%20subtle%20isometric%20cubes%20floating%20above%20the%20scene%2C%20cinematic%20wide%20composition%20with%20deep%20contrast%20suitable%20for%20corporate%20technology%20hero%20background%2C%20stylized%20artistic%20not%20photo%20realistic&width=1920&height=1080&seq=skyedge-hero-01&orientation=landscape')",
        }}
      />
      {/* Dark overlays */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-950/85 via-primary-900/70 to-primary-800/60" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40" />
      <div className="absolute inset-0 bg-grid-pattern opacity-40" />

      {/* Floating decorative shapes */}
      <div className="absolute top-24 right-10 md:right-24 w-40 h-40 rounded-2xl border border-accent-500/30 rotate-12 animate-float-y hidden md:block" />
      <div className="absolute bottom-24 left-10 md:left-24 w-24 h-24 rounded-full bg-accent-500/10 border border-accent-500/30 animate-float-y hidden md:block" style={{ animationDelay: '1.5s' }} />

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-8 pt-28 md:pt-32 pb-16">
        <div className="flex flex-col items-center text-center w-full">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur mb-6 animate-fade-up">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
            <span className="text-xs md:text-sm text-background-100 font-medium tracking-wide">
              Armenia × India · 120+ engineers · 15+ years
            </span>
          </div>

          <h1 className="font-heading font-bold text-4xl md:text-6xl lg:text-7xl text-background-50 leading-[1.05] max-w-4xl animate-fade-up" style={{ animationDelay: '0.1s' }}>
            Engineering the <span className="text-accent-400">edge</span> of enterprise technology
          </h1>

          <p className="mt-6 text-base md:text-xl text-background-200 max-w-3xl leading-relaxed animate-fade-up" style={{ animationDelay: '0.2s' }}>
            Sky Edge Infotech builds custom software, runs the GDB Cloud data centre,
            ships AI agentic tools, and tokenizes real-world assets — end-to-end,
            from issuance to marketplace compliance.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-up" style={{ animationDelay: '0.3s' }}>
            <a
              href="#products"
              className="w-full sm:w-auto px-8 py-4 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap transition-all cursor-pointer inline-flex items-center justify-center gap-2"
            >
              Explore our products
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <a
              href="#contact"
              className="w-full sm:w-auto px-8 py-4 rounded-md bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap transition-all cursor-pointer inline-flex items-center justify-center gap-2 backdrop-blur"
            >
              <i className="ri-calendar-line text-lg"></i>
              Book a consultation
            </a>
          </div>

          {/* Client / capability row */}
          <div className="mt-16 md:mt-20 w-full max-w-4xl animate-fade-up" style={{ animationDelay: '0.4s' }}>
            <p className="text-xs uppercase tracking-widest text-background-300 mb-6">Capabilities across the stack</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { icon: 'ri-code-s-slash-line', label: 'Custom Software' },
                { icon: 'ri-server-line', label: 'GDB Data Centre' },
                { icon: 'ri-robot-2-line', label: 'AI Agentic Tools' },
                { icon: 'ri-coin-line', label: 'RWA Tokenization' },
              ].map((c) => (
                <div key={c.label} className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50/5 border border-background-50/10 backdrop-blur">
                  <div className="w-10 h-10 flex items-center justify-center text-accent-400">
                    <i className={`${c.icon} text-2xl`}></i>
                  </div>
                  <span className="text-xs md:text-sm text-background-100 font-medium text-center whitespace-nowrap">{c.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-background-200">
        <span className="text-[10px] uppercase tracking-widest">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-background-200 to-transparent" />
      </div>
    </section>
  );
}